// axisColors — X / Y / Z identity colors for transform UI.
//
// FUNCTIONAL colors, not themed ones: red/green/blue for X/Y/Z is a convention
// every DCC shares (Unreal, Unity, Blender, Maya), and it must match the
// TransformControls gizmo standing in the viewport next to these fields. A
// palette switch retinting the axes would break the pairing between the field
// you type in and the handle you drag — same reasoning as node pin colors and
// waypoint category colors, both of which are likewise allowlisted in
// tests/unit/paletteEnforcement.test.mjs.
//
// Values are three.js's own gizmo axis colors, so the numbers here and the
// arrows in the viewport are literally the same red, green and blue.

export const AXIS_COLORS = Object.freeze({
  x: '#ff3653',
  y: '#8adb00',
  z: '#2c8fff',
})

/** The identity color for an axis, or the neutral token when it isn't one. */
export function axisColor(axis) {
  return AXIS_COLORS[axis] ?? 'var(--m-fg-3)'
}

export default AXIS_COLORS
